export enum AvailableFilterFolds {
  Gefalts = 'G', //gefälzt
  Stumpf = 'S', //stumpf
  All = 'AlleFolds'
}

export const CATEGORY_ALL = 'Alle';
